import TableView from "../Common/TableView";
import { generalObjectBuilder, genericDelete, genericPost, genericUpdate, OCORRENCIAS_EXTENSION, ORCAMENTOS_EXTENSION, paginatedGetWithProcessor } from "../../services/api.service";
import { ViewHeader } from "../Common/ViewHeader";
import { OcorrenciasTableConfig } from "./Ocorrencias.config";


export default function Ocorrencias() {

    return (<div className="max-h-screen">
        <TableView
            title={"Ocorrências"}
            getEntity={paginatedGetWithProcessor(OCORRENCIAS_EXTENSION, generalObjectBuilder(OcorrenciasTableConfig))}
            postEntity={genericPost(OCORRENCIAS_EXTENSION)}
            editEntity={genericUpdate(OCORRENCIAS_EXTENSION)}
            deleteEntity={genericDelete(OCORRENCIAS_EXTENSION)}
            addButtonText={"Nova Ocorrência"}
            tableConfigs={OcorrenciasTableConfig}
            dataBuildFunction={generalObjectBuilder(OcorrenciasTableConfig)}
            entityName={"Ocorrência"}
            idProp={"id"}
            reroute={true}
        />
    </div>)

}

